import React from 'react'
import {
  format,
  isSameDay
} from 'date-fns'
import {
  Icon,
  Popup
} from 'semantic-ui-react'
import { connect } from 'react-redux'
// Local
import {
  FORMAT,
  LOCK,
  REVIEW
} from '../../../constant'
import { Encounter } from '../../authenticated/types'
import { expandSpecialtyFilter } from '../../common/ruleFilterUtils'
import { isCancelledEncounter } from '../../patient/utils'
import If from '../../common/if'
import { RootState } from '../../../store'

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>

type Props = ReduxStateProps & {
  encounter: Encounter
}

function CdiEncounterStatusIcon(
  props: Props
): JSX.Element {
  const {
    currentUser,
    encounter
  } = props

  const userName = (
    encounter &&
    encounter.lock &&
    encounter.lock.createdByUsername
  )
  const lockMessageDate = (
    encounter &&
    encounter.lock &&
    encounter.lock.creationDate
  )

  const lockMessage = `Locked for ${userName}, ${format(lockMessageDate || '', FORMAT.DATE_TIME)}`

  const lockColor = (
    encounter &&
    encounter.lock &&
    encounter.lock.createdById === currentUser.userId
  )
    ? 'green'
    : 'black'

  const sameDayEncounter = (
    ingestDate: Date | string | null | undefined,
    startDate: Date | string | null | undefined
  ) => (
    ingestDate &&
    startDate &&
    isSameDay(
      ingestDate,
      startDate
    )
  )

  const lastFilter = (
    encounter &&
    encounter.patient &&
    encounter.patient.rulesFilterSpecialtyPrefix
  )
    ? encounter.patient.rulesFilterSpecialtyPrefix
    : ''

  const fullSpecialtyName = lastFilter === ''
    ? ''
    : expandSpecialtyFilter(lastFilter)

  return (
    <span>
      <If isTrue={
        !!encounter.lock &&
        encounter.lock.statusCode === LOCK.STATUS.ACTIVE
      }
      >
        <Popup
          mouseEnterDelay={ 500 }
          content={ lockMessage }
          trigger={
            <Icon
              name="lock"
              color={ lockColor }
            />
          }
        />
      </If>
      <If isTrue={
        !!sameDayEncounter(
          encounter.ingestDate,
          encounter.start
        )
      }
      >
        <Popup
          mouseEnterDelay={ 500 }
          content="Same Day Encounter"
          trigger={
            <Icon
              name="rocket"
              color="red"
            />
          }
        />
      </If>
      <If isTrue={ isCancelledEncounter(encounter) }>
        <Popup
          mouseEnterDelay={ 1000 }
          content="Cancelled"
          trigger={
            <Icon
              name="times circle"
              color="red"
            />
          }
        />
      </If>
      <If isTrue={
        !!encounter.review
        && encounter.review.reviewCode === REVIEW.CODE.READY_FOR_CDI_QA
      }
      >
        <Popup
          mouseEnterDelay={ 1000 }
          content="Ready for CDI QA"
          trigger={
            <Icon
              name="question circle"
              color="yellow"
            />
          }
        />
      </If>
      <If isTrue={
        !!encounter.review
        && encounter.review.reviewCode === REVIEW.CODE.READY_FOR_PHYSICIAN
      }
      >
        <Popup
          mouseEnterDelay={ 1000 }
          content="Ready for Physician"
          trigger={
            <Icon
              name="checkmark"
              color="green"
            />
          }
        />
      </If>
      <If isTrue={
        !!encounter.review
        && encounter.review.queryStatusCode === REVIEW.QUERY_STATUS.REVIEW_QUERY_OUTSTANDING
      }
      >
        <Popup
          mouseEnterDelay={ 1000 }
          content="CDI Review Requested"
          trigger={ <Icon name="hourglass half" color="red" /> }
        />
      </If>
      <If isTrue={ !!fullSpecialtyName }>
        <Popup
          mouseEnterDelay={ 1000 }
          content={ fullSpecialtyName }
          trigger={
            <Icon
              name="doctor"
              color="blue"
            />
          }
        />
      </If>
    </span>
  )
}

export default connect(mapStateToProps)(CdiEncounterStatusIcon)
